module.exports = __webpack_public_path__ + "media/images/front/treatment_support/icon_feeling05_gray-f0167dad4cae66fc01a749094212b0b9.svg";